import React, { lazy } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import EsperarComponente from './shared/layout/EsperarComponente';
import { pageRoutes } from './shared/util/Constantes';

const TestList = lazy(() => import('./features/listaDeProvas'));
const TestRoom = lazy(() => import('./features/testRoom'));
const Login = lazy(() => import('./features/login'));
const AccuracyRate = lazy(() => import('./features/accuracyRate'));
const TestManual = lazy(() => import('./features/manual'));

export const Routes = ({ estaAutenticado }) => {
  let rotas;

  if (estaAutenticado) {
    rotas = (
      <Switch>
        <Route
          exact
          path={pageRoutes.TestList}
          component={EsperarComponente(TestList)}
        />
        <Route
          exact
          path={pageRoutes.TestRoom}
          component={EsperarComponente(TestRoom)}
        />
        <Route
          exact
          path={pageRoutes.AccuracyRate}
          component={EsperarComponente(AccuracyRate)}
        />
        <Route
          exact
          path={pageRoutes.TestManual}
          component={EsperarComponente(TestManual)}
        />
        <Redirect to={pageRoutes.TestManual} />
      </Switch>
    );
  } else {
    rotas = (
      <Switch>
        <Route
          exact
          path={pageRoutes.Login}
          component={EsperarComponente(Login)}
        />
        <Redirect to={pageRoutes.Login} />
      </Switch>
    );
  }

  const AppRoutes = withRouter(() => rotas);
  return <AppRoutes />;
};

export default Routes;
